// @ts-ignore
import mixpanel from "mixpanel-browser";

try {
  mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
    debug: true,
    track_pageview: true,
    persistence: "localStorage",
  });
} catch (error) {
  console.log("Failed to initialize Mixpanel:", error);
}
export const Mixpanel = {
  identify: (id: any) => {
    mixpanel.identify(id);
  },
  track: (name: string, props: any) => {
    try {
      mixpanel.track(name, props);
    } catch (error) {
      console.error("Failed to track event:", error);
    }
  },
  people: {
    set: (props: any) => {
      mixpanel.people.set(props);
    },
  },
};
